module.exports = __webpack_public_path__ + "media/error.5235f7df.mp3";